import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Row, Col, Input, Table, Select, Tag, Button } from "antd";
// import { Link } from "react-router-dom";
// import { DownOutlined } from '@ant-design/icons';
// import Docsample from '../../Images/docsample.png';

import { withAppContext } from "../../store/contextStore";
import AppConfigs from "../../Config/AppConfig";
import { list } from "../../api/Apis";
import {
  formatPhoneNumber,
  formatPhoneNumber1,
  showTotal,
} from "../commonFunctions";
import ResizableAntdTable from "resizable-antd-table";
import ErrorPage from "../ErrorPage";
import DownloadCsv from "../../Components/DownloadCsv";

const Search = Input.Search;
const { Option } = Select;

class Carriers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      carriersList: [],
      totalCarriersList: [],
      dataLoadingStatus: true,
      masterData: [],
      userDetails: JSON.parse(localStorage.getItem("userDetails")),
    };
  }

  componentDidMount() {
    let query = {
      dataType: "carrierTag",
      recordStatus: true,
    };
    list(AppConfigs["entityNames"]["masterData"], query).then((result) => {
      if (result.success) {
        let masterData = result.data;
        this.setState({
          masterData: masterData,
        });
        query = {
          registrationType: "carrier",
        };
        list(AppConfigs["entityNames"]["registrations"], query).then(
          (result) => {
            if (result.success) {
              let carriersList = result.data.sort((a, b) =>
                parseInt(a["createdAt"]) < parseInt(b["createdAt"]) ? 1 : -1
              );
              carriersList.map((carrier) => {
                carrier["typeOfTrucks"] = [];
                if ("tags" in carrier) {
                  let tagNames = [];
                  carrier["tags"].map((tag) => {
                    tagNames.push(
                      masterData.filter((t) => t.id === tag)[0]["name"]
                    );
                    return tag;
                  });
                  carrier["tagNames"] = tagNames;
                }
                if (
                  "carrierFiles" in carrier &&
                  "trucks" in carrier["carrierFiles"]
                ) {
                  carrier["carrierFiles"]["trucks"].map((truck) => {
                    if (
                      carrier["typeOfTrucks"].indexOf(truck.typeOfTruck) === -1
                    ) {
                      carrier["typeOfTrucks"].push(truck.typeOfTruck);
                    }
                    return truck;
                  });
                }
                carrier["typeOfTrucks"] = carrier["typeOfTrucks"].join(", ");
                return carrier;
              });
              carriersList = carriersList.filter(
                (item) => item.userProfile !== "SCA"
              );
              this.setState({
                carriersList: carriersList,
                totalCarriersList: result.data,
                dataLoadingStatus: false,
              });
            } else {
              this.setState({
                dataLoadingStatus: false,
              });
              console.log(result.errors);
            }
          }
        );
      } else {
        console.log(result.errors);
        this.setState({
          dataLoading: false,
        });
      }
    });
  }

  searchData = (event, searchType) => {
    let searcingValue = searchType === "text" ? event.target.value : event;
    let totalCarriersList = [];
    if (searcingValue.length > 0) {
      searcingValue = searcingValue.toLowerCase();
      if (searchType === "text") {
        // totalCarriersList = this.state.totalCarriersList.filter((carrier) => carrier.companyName.toLowerCase().indexOf(searcingValue) > -1 || carrier.address.toLowerCase().indexOf(searcingValue) > -1 || carrier.phone.indexOf(searcingValue) > -1 || carrier.email.toLowerCase().indexOf(searcingValue) > -1)
        totalCarriersList = this.state.totalCarriersList.filter(
          (carrier) =>
            (carrier?.companyName !== null &&
              carrier?.companyName?.toLowerCase().indexOf(searcingValue) >
                -1) ||
            (carrier?.address !== null &&
              carrier?.address?.toLowerCase().indexOf(searcingValue) > -1) ||
            (carrier?.phone !== null &&
              carrier?.phone.indexOf(searcingValue) > -1) ||
            (carrier?.email !== null &&
              carrier?.email?.toLowerCase().indexOf(searcingValue) > -1) ||
            (carrier?.typeOfTrucks !== null &&
              carrier?.typeOfTrucks?.toLowerCase().indexOf(searcingValue) > -1)
        );
        totalCarriersList = totalCarriersList.filter(
          (item) => item.userProfile !== "SCA"
        );
      } else {
        totalCarriersList = this.state.totalCarriersList.filter(
          (carrier) => carrier.approvalStatus.toLowerCase() === searcingValue
        );
      }
    } else {
      totalCarriersList = this.state.totalCarriersList;
    }
    this.setState({
      carriersList: totalCarriersList,
    });
  };

  addCarrier = () => {
    this.props.history.push("/app/addcarrier");
  };

  handleTableChange = (pagination, filters, sorter) => {
    let carriersList = [];
    if (sorter["order"] === "descend") {
      if (sorter["columnKey"] === "approvalStatus") {
        carriersList = this.state.carriersList.sort((a, b) =>
          AppConfigs["CARRIER_AND_CUSTOMER_STATUS"][a["approvalStatus"]] <
          AppConfigs["CARRIER_AND_CUSTOMER_STATUS"][b["approvalStatus"]]
            ? 1
            : -1
        );
      } else if (sorter["columnKey"] === "phone") {
        carriersList = this.state.carriersList.sort((a, b) =>
          parseInt(a["phone"]) < parseInt(b["phone"]) ? 1 : -1
        );
      } else if (sorter["columnKey"] === "companyName") {
        carriersList = this.state.carriersList.sort((a, b) =>
          a["companyName"].toLowerCase() < b["companyName"].toLowerCase()
            ? 1
            : -1
        );
      } else if (sorter["columnKey"] === "email") {
        carriersList = this.state.carriersList.sort((a, b) =>
          a["email"].toLowerCase() < b["email"].toLowerCase() ? 1 : -1
        );
      } else if (sorter["columnKey"] === "address") {
        carriersList = this.state.carriersList.sort((a, b) =>
          a["address"].toLowerCase() < b["address"].toLowerCase() ? 1 : -1
        );
      } else if (sorter["columnKey"] === "tags") {
        carriersList = this.state.carriersList
          .filter((c) => c["tags"])
          .sort((a, b) =>
            a["tags"].join(",").toLowerCase() <
            b["tags"].join(",").toLowerCase()
              ? 1
              : -1
          );
        carriersList = carriersList.concat(
          this.state.carriersList.filter((c) => !c["tags"])
        );
      } else if (sorter["columnKey"] === "typeOfTrucks") {
        carriersList = this.state.carriersList.sort((a, b) =>
          a["typeOfTrucks"].toLowerCase() < b["typeOfTrucks"].toLowerCase()
            ? 1
            : -1
        );
      }
    } else if (sorter["order"] === "ascend") {
      if (sorter["columnKey"] === "approvalStatus") {
        carriersList = this.state.carriersList.sort((a, b) =>
          AppConfigs["CARRIER_AND_CUSTOMER_STATUS"][a["approvalStatus"]] >
          AppConfigs["CARRIER_AND_CUSTOMER_STATUS"][b["approvalStatus"]]
            ? 1
            : -1
        );
      } else if (sorter["columnKey"] === "phone") {
        carriersList = this.state.carriersList.sort((a, b) =>
          parseInt(a["phone"]) > parseInt(b["phone"]) ? 1 : -1
        );
      } else if (sorter["columnKey"] === "companyName") {
        carriersList = this.state.carriersList.sort((a, b) =>
          a["companyName"].toLowerCase() > b["companyName"].toLowerCase()
            ? 1
            : -1
        );
      } else if (sorter["columnKey"] === "email") {
        carriersList = this.state.carriersList.sort((a, b) =>
          a["email"].toLowerCase() > b["email"].toLowerCase() ? 1 : -1
        );
      } else if (sorter["columnKey"] === "address") {
        carriersList = this.state.carriersList.sort((a, b) =>
          a["address"].toLowerCase() > b["address"].toLowerCase() ? 1 : -1
        );
      } else if (sorter["columnKey"] === "tags") {
        carriersList = this.state.carriersList
          .filter((c) => c["tags"])
          .sort((a, b) =>
            a["tags"].join(",").toLowerCase() >
            b["tags"].join(",").toLowerCase()
              ? 1
              : -1
          );
        carriersList = carriersList.concat(
          this.state.carriersList.filter((c) => !c["tags"])
        );
      } else if (sorter["columnKey"] === "typeOfTrucks") {
        carriersList = this.state.carriersList.sort((a, b) =>
          a["typeOfTrucks"].toLowerCase() > b["typeOfTrucks"].toLowerCase()
            ? 1
            : -1
        );
      }
    } else {
      carriersList = this.state.carriersList;
    }
    this.setState({
      carriersList: carriersList,
    });
  };

  render() {
    // const tablemenu = (id) =>(
    //   <Menu>
    //     <Menu.Item className='blue' >
    //       <Link to={"/app/carriers/carrierdetails/"+id}>Details</Link>
    //     </Menu.Item>
    //   </Menu>
    // )

    const columns = [
      {
        title: <div style={{ color: "gray" }}>Status</div>,
        key: "approvalStatus",
        dataIndex: "approvalStatus",
        // sorter: true,
        render: (tag) => (
          <span className="status_tag">
            <Tag
              color={tag === "A" ? "green" : tag === "P" ? "yellow" : "red"}
              key={tag}
              style={{
                color: "black",
                height: "27px",
                fontSize: "12px",
                fontWeight: "bold",
              }}
            >
              {tag === "A" ? "Approved" : tag === "P" ? "Pending" : "Rejected"}
            </Tag>
            {/* <div style={{color: 'black'}}>{approvalStatus}</div> */}
          </span>
        ),
      },

      {
        title: <div style={{ color: "gray" }}>Company</div>,
        dataIndex: "companyName",
        key: "companyName",
        // sorter: true,
        render: (company) => (
          <span>
            <div style={{ color: "black" }}>{company}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Phone</div>,
        dataIndex: "phone",
        key: "phone",
        // sorter: true,
        width: 150,
        render: (phone) => (
          <span>
            {/* <PhoneInput country="US" value={phone} /> */}
            <div style={{ color: "black" }}>
              {phone.length === 10
                ? formatPhoneNumber(phone)
                : formatPhoneNumber1(phone)}
            </div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Email</div>,
        dataIndex: "email",
        key: "email",
        // sorter: true,
        render: (email) => (
          <span>
            <div style={{ color: "black" }}>{email}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Address</div>,
        dataIndex: "address",
        key: "address",
        // sorter: true,
        render: (address) => (
          <span>
            <div style={{ color: "black" }}>{address}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Type of trucks</div>,
        dataIndex: "typeOfTrucks",
        key: "typeOfTrucks",
        // sorter: true,
        render: (typeOfTrucks) => (
          <span>
            <div style={{ color: "black" }}>{typeOfTrucks}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Tags</div>,
        dataIndex: "tagNames",
        key: "tagNames",
        // sorter: true,
        render: (tagNames) => (
          <span>
            <div style={{ color: "black" }}>
              {tagNames && tagNames.join(", ")}
            </div>
          </span>
        ),
      },

      // {
      //   title: '',
      //   dataIndex: 'id',
      //   key: 'ordermenu',
      //   render: (text, record) => (
      //     <Dropdown overlay={tablemenu(text)} placement="bottomRight">
      //       <Button>...</Button>
      //     </Dropdown>
      //   ),
      // }
    ];

    if (
      this.state.userDetails.userProfile !== "A" &&
      this.state.userDetails.userProfile !== "M"
    ) {
      return <ErrorPage />;
    }

    return (
      <div className="content-outer">
        <div className="content">
          <Row>
            <Col xs={24} sm={24} md={24} lg={24}>
              <h1 className="headings"> Carriers </h1>
            </Col>
            <Row style={{ marginTop: "10px", }}>
              <Col xs={24} sm={24} md={4} lg={4} style={{ marginTop: "1%" }}>
                <Search
                  className="products-search"
                  size="large"
                  placeholder="Search"
                  onChange={(event) => this.searchData(event, "text")}
                />
              </Col>
              <Col xs={24} sm={24} md={2} lg={2} style={{ marginTop: "1%" }}>
                <div className="vl" />
              </Col>
              <Col xs={24} sm={24} md={3} lg={2} style={{ marginTop: "1%" }}>
                <div className="loads-select">
                  <Select
                    onChange={(event) => this.searchData(event, "status")}
                    placeholder={"State"}
                    defaultValue="All Status"
                    style={{ width: 140 }}
                  >
                    <Option key="All" value="">
                      All Status
                    </Option>
                    <Option key="A" value="A">
                      Approved
                    </Option>
                    <Option key="P" value="P">
                      Pending
                    </Option>
                    <Option key="D" value="D">
                      Declined
                    </Option>
                  </Select>
                  {/* <Button>
                    <DownloadCsv
                      data={this.state.carriersList}
                      columns={columns}
                      filename="Carriers"
                      />
                    </Button> */}
                </div>
              </Col>
              {/* <Col xs={24} sm={24} md={12} lg={12} >
                <Button type="primary" htmlType="submit" loading={this.state.loading} className="customer-add-button" onClick={() => this.addCarrier()} icon='plus'>
                  Carrier
                </Button>
              </Col> */}
              <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: "2%" }}>
                <ResizableAntdTable
                  style={{ overflowX: "auto" }}
                  bordered={true}
                  columns={columns}
                  dataSource={this.state.carriersList}
                  loading={this.state.dataLoadingStatus}
                  rowKey={(record) => record.id}
                  onChange={this.handleTableChange}
                  pagination={{
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    pageSizeOptions: ["10", "25", "50", "100"],
                    total: this.state.carriersList.length,
                    showTotal: showTotal,
                  }}
                  onRow={(r) => ({
                    onClick: () =>
                      (window.location =
                        "/app/carriers/carrierdetails/" + r.id),
                    style: { cursor: "pointer" },
                  })}
                />
              </Col>
            </Row>
            <Button>
              <DownloadCsv
                data={this.state.carriersList}
                columns={columns}
                filename="Carriers"
              />
            </Button>
          </Row>
        </div>
      </div>
    );
  }
}
export default withAppContext(withRouter(Carriers));
